import * as React from 'react';
// import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';
import ApproveAlertDialog from './ApproveDialog';
import RejectAlertDialog from './RejectDialog';
import { ApproveTopupRequest } from 'API/Limit_Topup_Checker/api';
import { Stack } from '@mui/system';
import { IoEyeSharp } from 'react-icons/io5';
import StatementStatusDialog from './StatementStatusDialog';
import { FaDownload } from 'react-icons/fa6';
import TablePagination from '@mui/material/TablePagination';
import Checkbox from '@mui/material/Checkbox';

// import { styled } from '@mui/material/styles';

function formatDate(dateString) {
  const date = new Date(dateString);

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;

  return `${formattedDate}`;
}

// const paginationModel = { page: 0, pageSize: 10 };

export default function TopupCheckerTable(props) {
  const [OpenApproveDialog, setOpenApproveDialog] = useState(false);
  const [OpenRejectDialog, setOpenRejectDialog] = useState(false);
  const [OpenStatementDialog, setOpenStatementDialog] = useState(false);
  const [PostData, setPostData] = useState({ action: '', reason: '', topupid: '' });
  // const [selectedRows, setSelectedRows] = React.useState([]);
  const [StatementSelected, setStatementSelected] = React.useState(null);
  const [Page, setPage] = useState(0);
  const rowsperpage = 10;
  const [selectedRows, setSelectedRows] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);

  // console.log("Selected rows",selectedRows);

  const handleSelectAll = () => {
    if (isAllSelected) {
      setSelectedRows([]);
    } else {
      setSelectedRows(props.data.map((row) => row.topupid));
    }
    setIsAllSelected(!isAllSelected);
  };

  const handleCheckboxChange = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((selectedId) => selectedId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };

  // const useStyles = makeStyles({
  //   root: {
  //     '& .MuiDataGrid-row': {
  //       padding: '16px 8px', // Adjust the padding as needed
  //     },
  //   },
  //   cell: {
  //     whiteSpace: 'normal',
  //     wordWrap: 'break-word',
  //   },
  // });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleApproveClose = () => {
    setOpenApproveDialog(false);
  };

  const handleRejectClose = () => {
    setOpenRejectDialog(false);
  };

  const handleApproveOpen = () => {
    if (Array.isArray(selectedRows) && selectedRows.length > 0) {
      setOpenApproveDialog(true);
      setPostData({ action: 'A', reason: '', topupids: selectedRows });
    } else {
      props.alert('Please select at least one request', 'error');
    }
  };

  const handleRejectOpen = () => {
    if (Array.isArray(selectedRows) && selectedRows.length > 0) {
      setOpenRejectDialog(true);
      setPostData({ action: 'X', reason: '', topupids: selectedRows });
    } else {
      props.alert('Please select at least one request', 'error');
    }
  };

  const handleApprove = () => {
    ApproveTopupRequest(PostData, setPostData, props.setIsLoading, props.alert, handleApproveClose, props.handleSearch);
  };

  const handleReject = () => {
    if (PostData.reason) {
      console.log('PostData', PostData);
      ApproveTopupRequest(PostData, setPostData, props.setIsLoading, props.alert, handleRejectClose, props.handleSearch);
    } else {
      props.alert('Please enter reason', 'error');
      return;
    }
  };

  // const handleSelectionChange = (newSelection) => {
  //   setSelectedRows(newSelection);
  // };

  const handleReasonChange = (value) => {
    setPostData({ ...PostData, reason: value });
  };

  const hadleStatementSelect = (params) => {
    console.log('params', params);

    setStatementSelected(params);
    setOpenStatementDialog(true);
  };

  const handleStatementDialogClose = () => [setOpenStatementDialog(false), setStatementSelected(null)];

  const columns = [
    {
      field: 'topupid',
      headerName: 'Request Id',
      width: 65,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordWrap: 'break-word', // Adding padding inside the cell
            lineHeight: '1.5'
          }}
        >
          {params.value}
        </div>
      )
    },
    {
      field: 'usercodewithname',
      headerName: 'Request From',
      width: 100,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordWrap: 'break-word', // Adding padding inside the cell
            lineHeight: '1.5'
          }}
        >
          {params.row.usercodewithname}
        </div>
      )
    },
    {
      field: 'statename',
      headerName: 'State',
      type: 'text',
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordWrap: 'break-word', // Adding padding inside the cell
            lineHeight: '1.5'
          }}
        >
          {params.row.statename}
        </div>
      ),
      width: 70
    },
    {
      field: 'districtname',
      headerName: 'District',
      type: 'text',
      width: 70,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordWrap: 'break-word', // Adding padding inside the cell
            lineHeight: '1.5'
          }}
        >
          {params.row.districtname}
        </div>
      )
    },
    {
      field: 'createddate',
      headerName: 'Request Date',
      type: 'text',
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordWrap: 'break-word', // Adding padding inside the cell
            lineHeight: '1.5'
          }}
        >
          {formatDate(params.value)}
        </div>
      ),
      width: 60
    },
    {
      field: 'topupamount',
      headerName: 'Topup Amount',
      type: 'text',
      width: 70,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordWrap: 'break-word', // Adding padding inside the cell
            lineHeight: '1.5'
          }}
        >
          {params.value}
        </div>
      )
    },
    {
      field: 'topupmodeNM',
      headerName: 'Topup Type',
      type: 'text',
      width: 60
    },
    {
      field: 'ref1',
      headerName: 'Ref 1',
      type: 'text',
      width: 85,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordWrap: 'break-word', // Adding padding inside the cell
            lineHeight: '1.5'
          }}
        >
          {params.value}
        </div>
      )
    },
    {
      field: 'ref2',
      headerName: 'Ref 2',
      type: 'text',
      width: 85,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordWrap: 'break-word', // Adding padding inside the cell
            lineHeight: '1.5',
            display: 'flex',
            flexWrap: 'wrap'
          }}
        >
          {params.value}
        </div>
      )
    },

    {
      field: 'benebank',
      headerName: 'Bank Name',
      type: 'text',
      width: 100,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordWrap: 'break-word', // Adding padding inside the cell
            lineHeight: '1.5'
          }}
        >
          {params.value}
        </div>
      )
    },

    {
      field: 'instrumentdate',
      headerName: 'Transfer Date',
      type: 'text',
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordWrap: 'break-word', // Adding padding inside the cell
            lineHeight: '1.5'
          }}
        >
          {formatDate(params.value)}
        </div>
      ),
      width: 60
    },
    {
      field: 'ai_status',
      headerName: 'AI Status',
      type: 'text',
      renderCell: (params) => (
        <Stack direction="column" gap={0.5} alignItems="center">
          <Button variant="outlined" color="secondary" size="small" onClick={() => hadleStatementSelect(params)}>
            <IoEyeSharp />
          </Button>
          <Typography sx={{ fontSize: '0.7rem' }}>{params.value ? params.value : 'Pending'}</Typography>
        </Stack>
      ),
      width: 80
    },
    {
      field: 'status',
      headerName: 'Status',
      type: 'text',
      renderCell: (params) => <div>{params.row.status === 'A' ? 'Approved' : params.row.status === 'X' ? 'Rejected' : 'Pending'}</div>,
      width: 80
    },
    {
      field: 'download_icon',
      headerName: 'Download',
      type: 'text',
      renderCell: (params) =>
        params.row.topupmodeNM === 'Cash' ? (
          <Button color="secondary" disabled>
            <FaDownload />
          </Button>
        ) : null,
      width: 65
    },
    {
      field: 'reason',
      headerName: 'Reason',
      type: 'text',
      width: 60
    },
    {
      field: 'remarks',
      headerName: 'Remarks',
      type: 'text',
      width: 60
    }

    // {
    //   field: 'usercodewithname',
    //   headerName: 'Full name',
    //   description: 'This column has a value getter and is not sortable.',
    //   sortable: false,
    //   width: 160,
    // },
  ];

  // console.log("SelectedData", selectedRows);

  // const StyledDataGrid = styled(DataGrid)(() => ({
  //   '& .MuiDataGrid-columnHeader': {
  //     whiteSpace: 'normal',
  //     wordWrap: 'break-word',
  //     lineHeight: '1.5',
  //     display: 'flex',
  //     alignItems: 'center',
  //     justifyContent: 'center',
  //     textAlign: 'center',
  //     padding: '8px', // Adjust padding as needed
  //   },
  //   '& .MuiDataGrid-columnHeaderTitleContainer': {
  //     display: 'flex',
  //     alignItems: 'center',
  //     justifyContent: 'center',
  //     textAlign: 'center',
  //     whiteSpace: 'normal',
  //     wordWrap: 'break-word',
  //   },
  //   '& .MuiDataGrid-cell': {
  //     whiteSpace: 'normal',
  //     wordWrap: 'break-word',
  //     height: 'max-content',
  //     lineHeight: '1.5',
  //     padding: '1px' // Adjusting line-height to avoid text merging
  //   },
  //   '& .MuiDataGrid-row': {
  //     height: 'max-content',
  //   },

  // }));

  return (
    <Paper sx={{ height: '100%', width: '100%' }}>
      <ApproveAlertDialog
        isLoading={props.IsLoading}
        open={OpenApproveDialog}
        handleClose={handleApproveClose}
        handleSubmit={handleApprove}
      />
      <RejectAlertDialog
        isLoading={props.IsLoading}
        open={OpenRejectDialog}
        handleClose={handleRejectClose}
        handleSubmit={handleReject}
        handleChange={handleReasonChange}
        data={PostData}
      />
      <StatementStatusDialog
        isLoading={props.IsLoading}
        open={OpenStatementDialog}
        handleClose={handleStatementDialogClose}
        data={StatementSelected}
      />

      <Stack direction="row" width="100%" justifyContent="space-between">
        <Button
          disabled={props.filter.status === 'P' ? true : true}
          variant="contained"
          color="success"
          size="small"
          onClick={() => handleApproveOpen()}
        >
          Approve
        </Button>
        <Button
          disabled={props.filter.status === 'P' ? true : true}
          variant="contained"
          color="error"
          size="small"
          onClick={() => handleRejectOpen()}
        >
          Reject
        </Button>
      </Stack>
      <Box height="100%" overflowY={'scroll'}>
        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
          <thead>
            <tr>
              <th
                style={{
                  padding: '3px',
                  textAlign: 'center',
                  backgroundColor: '#4d068c',
                  color: '#fff',
                  fontSize: '12px',
                  borderBottom: '2px solid #ddd'
                }}
              >
                <Checkbox
                  checked={isAllSelected}
                  sx={{
                    '&.Mui-checked': {
                      color: '#fff',
                      borderRadius: '50%'
                    }
                  }}
                  size="small"
                  color="primary"
                  onChange={handleSelectAll}
                />
              </th>
              {columns.map((item, index) => (
                <th
                  key={index}
                  style={{
                    padding: '5px',
                    textAlign: 'center',
                    backgroundColor: '#4d068c',
                    color: '#fff',
                    fontSize: '12px',
                    borderBottom: '2px solid #ddd'
                  }}
                >
                  {item.headerName}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {props.data && Array.isArray(props.data) && props.data.length > 0 ? (
              props.data.slice(Page * rowsperpage, Page * rowsperpage + 10).map((row, index) => (
                <tr
                  key={index}
                  style={{
                    fontSize: '8px',
                    textAlign: 'center',
                    backgroundColor: index % 2 === 0 ? '#eeebf2' : '#fff',
                    borderBottom: '1px solid #ddd'
                  }}
                >
                  <td style={{ padding: '3px', fontSize: '10px' }}>
                    <Checkbox
                      checked={selectedRows.indexOf(row.topupid) >= 0 ? true : false}
                      size="small"
                      color="secondary"
                      onChange={() => handleCheckboxChange(row.topupid)}
                    />
                  </td>
                  {columns.map((item, colIndex) => (
                    <td key={colIndex} style={{ padding: '3px', fontSize: '10px' }}>
                      {item.field === 'createddate' || item.field === 'instrumentdate' ? (
                        formatDate(row[item.field])
                      ) : item.field === 'status' ? (
                        row[item.field] === 'A' ? (
                          <span style={{ color: 'green' }}>Approved</span>
                        ) : row[item.field] === 'P' ? (
                          <span style={{ color: '#4d068c' }}>Pending</span>
                        ) : (
                          <span style={{ color: 'red' }}>Rejected</span>
                        )
                      ) : item.field === 'ai_status' ? (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                          <Button
                            variant="outlined"
                            color="secondary"
                            style={{ cursor: 'pointer', fontSize: '8px' }}
                            onClick={() => hadleStatementSelect(row)}
                            size="small"
                          >
                            <IoEyeSharp size={15} color="#4d068c" />
                          </Button>
                          <span style={{ fontSize: '10px' }}>{row[item.field] ? row[item.field] : 'Pending'}</span>
                        </div>
                      ) : item.field === 'download_icon' ? (
                        <Button disabled={row.topupmodeNM === 'Cash' ? true : true} variant="contained" color="secondary" size="small">
                          <FaDownload />
                        </Button>
                      ) : (
                        row[item.field]
                      )}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={16} style={{ textAlign: 'center' }}>
                  <p>No data</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* <DataGrid
        rows={props.data ? props.data : []}
        columns={columns}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[10]}
        getRowId={(row) => row.topupid}
        disableRowSelectionOnClick
        // onRowClick={((row) => hadleStatementSelect(row))}
        checkboxSelection={props.filter.status === 'P' ? true : false}
        onRowSelectionModelChange={(newSelection) => handleSelectionChange(newSelection)}
        sx={{
          '& .MuiDataGrid-cell': {
            fontSize: '0.75rem',
           wordBreak:'break-word',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'left',
            height:'100%',
            justifyContent: 'center'
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontSize: '0.7rem',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            lineHeight: '1.5',
            height: '100%',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            textAlign: 'left',
          },
        }}
        rowHeight={100}
        pinnedColumns={{ left: ['topupidl1', 'usercodewithname'] }}
      /> */}
        <TablePagination
          component="div"
          count={props.data ? props.data.length : 0}
          page={Page}
          onPageChange={handleChangePage}
          rowsPerPage={10}
          rowsPerPageOptions={[10]}
        />
      </Box>
    </Paper>
  );
}
